<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Fase:"
    id="selectFase"
    placeholder="Selecione a(s) Fase(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import FaseRepository from '@/shared/http/repositories/configurations/fase.js'

export default {
  name: 'NxSelectAjuizamentoFase',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadFases()
  },
  methods: {
    onLoadFases () {
      FaseRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Fases', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectAjuizamentoFase.vue